import React from 'react';
import { Button } from '../ui/button';
import { Check } from 'lucide-react';

export function PendingApprovals({ pendingTickets, selectedTickets, toggleTicketSelection, toggleSelectAll, handleBulkApprove, approvingBulk }) {
  if (pendingTickets.length === 0) return null;

  return (
    <div className="bg-[#0A0A0A] border-2 border-[#FFB800]/30 rounded-sm" data-testid="pending-approvals">
      <div className="p-6 border-b border-[#FFB800]/20 bg-[#FFB800]/5">
        <div className="flex justify-between items-center">
          <div><h2 className="text-xl font-semibold text-[#EAE7E1]">Pending Approvals</h2><p className="text-sm text-[#AFAFAF] mt-1">{pendingTickets.length} waiting</p></div>
          {selectedTickets.length > 0 && <Button onClick={handleBulkApprove} disabled={approvingBulk} className="bg-[#D4AF37] hover:bg-[#F2D27A] text-[#050505] rounded-sm px-6 py-3 font-bold" data-testid="bulk-approve-button"><Check className="w-4 h-4 mr-2" />{approvingBulk ? 'Approving...' : `Approve (${selectedTickets.length})`}</Button>}
        </div>
      </div>
      {/* Desktop table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#050505] border-b border-[#1A1A1A]"><tr>
            <th className="px-4 py-3"><input type="checkbox" checked={selectedTickets.length === pendingTickets.length && pendingTickets.length > 0} onChange={() => toggleSelectAll(pendingTickets)} className="rounded" /></th>
            {['Guest','Pass','Pax','Payment Ref','Method','Submitted'].map(h => <th key={h} className="px-4 py-3 text-left text-xs font-medium text-[#777] uppercase">{h}</th>)}
          </tr></thead>
          <tbody className="divide-y divide-[#1A1A1A]">{pendingTickets.map(t => (
            <tr key={t.ticket_id} className="hover:bg-[#0A0A0A]">
              <td className="px-4 py-4"><input type="checkbox" checked={selectedTickets.includes(t.ticket_id)} onChange={() => toggleTicketSelection(t.ticket_id)} className="rounded" /></td>
              <td className="px-4 py-4 text-sm font-medium text-[#EAE7E1]">{t.guest_name}</td>
              <td className="px-4 py-4 text-sm text-[#AFAFAF]">{t.pass_tier_name || '-'}</td>
              <td className="px-4 py-4 text-sm text-[#AFAFAF]">{t.attendees_count || 1}</td>
              <td className="px-4 py-4 text-sm text-[#AFAFAF] font-mono">{t.payment_confirmation}</td>
              <td className="px-4 py-4 text-sm"><span className="px-2 py-1 text-xs font-medium bg-[#1A1A1A] text-[#EAE7E1] rounded">{t.payment_method_used || '-'}</span></td>
              <td className="px-4 py-4 text-sm text-[#777]">{new Date(t.issued_at).toLocaleString()}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      {/* Mobile cards */}
      <div className="md:hidden divide-y divide-[#1A1A1A]">
        {pendingTickets.map(t => (
          <div key={t.ticket_id} className="p-4 flex items-start gap-3">
            <input type="checkbox" checked={selectedTickets.includes(t.ticket_id)} onChange={() => toggleTicketSelection(t.ticket_id)} className="rounded mt-1 flex-shrink-0" />
            <div className="min-w-0 flex-1 space-y-1">
              <div className="font-semibold text-sm text-[#EAE7E1] truncate">{t.guest_name}</div>
              <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-[#AFAFAF]">
                <span>{t.pass_tier_name || '-'}</span>
                <span>{t.attendees_count || 1} pax</span>
                <span className="px-1.5 py-0.5 bg-[#1A1A1A] text-[#EAE7E1] rounded text-[10px]">{t.payment_method_used || '-'}</span>
              </div>
              {t.payment_confirmation && <div className="text-xs text-[#555] font-mono truncate">{t.payment_confirmation}</div>}
              <div className="text-[10px] text-[#777]">{new Date(t.issued_at).toLocaleString()}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
